import { render, staticRenderFns } from "./production-workbench.vue?vue&type=template&id=3a52a1a5&"
import script from "./production-workbench.vue?vue&type=script&lang=js&"
export * from "./production-workbench.vue?vue&type=script&lang=js&"
import style0 from "./production-workbench.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports